import {createFeatureSelector, createSelector} from '@ngrx/store';
import {
	DigitalBoardState,
	DIGITAL_BOARD_FEATURE_KEY
} from './digital-board.reducer';

export const selectDigitalBoardState = createFeatureSelector<DigitalBoardState>(
	DIGITAL_BOARD_FEATURE_KEY
);

export const loaded = createSelector(
	selectDigitalBoardState,
	state => state.loaded
);

export const loading = createSelector(
	selectDigitalBoardState,
	state => state.loading
);

export const error = createSelector(
	selectDigitalBoardState,
	state => state.error
);

export const inPreparationOrders = createSelector(
	selectDigitalBoardState,
	state => state.inPreparationOrders
);

export const readyOrders = createSelector(
	selectDigitalBoardState,
	state => state.readyOrders
);

export const venueId = createSelector(
	selectDigitalBoardState,
	state => state.venueId
);
